import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="bg-white py-24 px-6" data-id="element-115">
      <div className="max-w-[1000px] mx-auto text-center" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="space-y-8" data-id="element-117">
          <span className="inline-block py-1 px-3 rounded-full bg-cream-dark text-forest font-sans font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-118">
            La Révélation
          </span>

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal leading-tight" data-id="element-119">
            Le problème n'est pas votre manque d'espace,
            <br className="hidden md:block" data-id="element-120" /> c'est votre méthode.
          </h2>

          <p className="font-sans text-lg md:text-xl text-charcoal/70 max-w-2xl mx-auto" data-id="element-121">
            Le jardinage traditionnel est lent et inefficace en ville. Vous avez
            besoin d'un{' '}
            <strong className="text-forest" data-id="element-122">Système de Haute Rotation</strong>.
          </p>

          <div className="py-8" data-id="element-123">
            <div className="h-px w-24 bg-accent mx-auto" data-id="element-124"></div>
          </div>

          <p className="font-sans text-lg md:text-xl text-charcoal max-w-3xl mx-auto leading-relaxed" data-id="element-125">
            J'ai condensé 5 ans d'expérimentation urbaine dans un pack numérique
            conçu pour un seul objectif : <br data-id="element-126" />
            <span className="font-bold text-forest text-xl md:text-2xl mt-2 block" data-id="element-127">
              Un maximum de calories et de nutriments sur un minimum de surface.
            </span>
          </p>

          <div className="pt-12" data-id="element-128">
            <p className="font-sans text-sm text-charcoal/50 uppercase tracking-widest mb-4" data-id="element-129">
              Présentation du pack
            </p>
            <h3 className="font-serif text-4xl md:text-5xl font-bold text-forest" data-id="element-130">
              RÉCOLTE URBAINE
            </h3>
            <p className="font-serif text-2xl text-accent mt-2 italic" data-id="element-131">
              Le Système Anti-Épicerie
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}